export default "/app/global-wrapper-client/static/67f8943e095a5c44bc2a1a9d2acd4c5b.woff";